/* @generated from adl module ferovinum.sourcecontracts.nominatedpurchaserterms */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.nominated_purchaser_terms` contract.
 */
export interface NominatedPurchaserTermsSource {
  id: ferovinum_app_db.NominatedPurchaserTermsId;
  termsHeader: (common_strings.StringNE|null);
  termsContent: (common_strings.StringNE|null);
  createdAt: common.Instant;
}

export function makeNominatedPurchaserTermsSource(
  input: {
    id: ferovinum_app_db.NominatedPurchaserTermsId,
    termsHeader: (common_strings.StringNE|null),
    termsContent: (common_strings.StringNE|null),
    createdAt: common.Instant,
  }
): NominatedPurchaserTermsSource {
  return {
    id: input.id,
    termsHeader: input.termsHeader,
    termsContent: input.termsContent,
    createdAt: input.createdAt,
  };
}

const NominatedPurchaserTermsSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.nominatedpurchaserterms","decl":{"annotations":[{"value":{"modelName":"source__app_db.nominated_purchaser_terms","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.nominated_purchaser_terms` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NominatedPurchaserTermsId"}},"parameters":[]}},{"annotations":[],"serializedName":"termsHeader","default":{"kind":"nothing"},"name":"termsHeader","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"termsContent","default":{"kind":"nothing"},"name":"termsContent","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"NominatedPurchaserTermsSource","version":{"kind":"nothing"}}};

export const snNominatedPurchaserTermsSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.nominatedpurchaserterms", name:"NominatedPurchaserTermsSource"};

export function texprNominatedPurchaserTermsSource(): ADL.ATypeExpr<NominatedPurchaserTermsSource> {
  return {value : {typeRef : {kind: "reference", value : snNominatedPurchaserTermsSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.nominatedpurchaserterms.NominatedPurchaserTermsSource" : NominatedPurchaserTermsSource_AST
};
